<template>
<div>


  <div class="container_wrapper">
    <!-- 排序 -->
    <div class="SortItem">
      <div class="resultTotal">
        共
        <span>{{hit}}</span> 条结果
      </div>
      <div class="sortBtn clear">
        <div
          class="orderByName"
          :class="this.$route.query.sortType === 'BookTitle' ? 'selectBtn': ''"
          @click="handleSort('BookTitle')"
        >
          按志书名排序
          <span class="iconfont">&#xe636;</span>
        </div>
        <div
          class="orderByTime"
          :class="this.$route.query.sortType === 'Date' ? 'selectBtn': ''"
          @click="handleSort('Date')"
        >
          按出版时间排序
          <span class="iconfont">&#xe636;</span>
        </div>
      </div>
    </div>

    <div class="container-inner clear" v-for="(item, index) of Facelist" :key="index">
      <div class="right">
        <img class="book-img" :src="BaseUrl + item.Id+'.gif'" v-if="item.Id" :onerror="defaultImg" />
        <img class="book-img" :src="BaseUrl + 'FZ201745248'+'.gif'" v-else />
      </div>
      <div class="left">
        <div class="reading" @click="handleCilicRead(item.Id)">
          <span class="iconfont">&#xe612;</span>
          在线阅读
        </div>
        <p class="itemTitle">
          <span class="itemTopic" @click="handleDetail(item.Id)">{{item.BookTitle | ellipsisTiltle}}</span>
        </p>
        <div>

        </div>
        <p class="itemMessage" v-if="item.Editor">
          <span v-if="item.Editor">编纂人员：&nbsp;&nbsp;</span>
          <span class="item" :title="item.Editor">{{item.Editor}}</span>
        </p>
        <p class="itemMessage" v-if="item.Publisher">
          <span v-if="item.Publisher">出版单位：&nbsp;&nbsp;</span>
          <span class="item" :title="item.Publisher">{{item.Publisher}}</span>
        </p>
        <p class="itemMessage" v-if="item.ISBN">
          <span v-if="item.ISBN">ISBN：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span class="item" :title="item.ISBN">{{item.ISBN}}</span>
        </p>
        <p class="itemMessage" v-if="item.Date">
          <span v-if="item.Date">出版时间：&nbsp;&nbsp;</span>
          <span class="item" :title="item.Date">{{item.Date}}</span>
        </p>
        <div style="background: #f2eeeb; padding: 20px;margin-top: 20px" v-if="item.Content">
          <p class="itemContent clear" v-if="item.Content" :title="item.Content">
            内容简介：
            {{item.Content}}
          </p>
        </div>
      </div>
    </div>
    <Pagination
      :total="hit"
      :currentPage= this.$route.query.pageNo*1
      :pageSize= "15"
      :totalPage = this.totalPage
      @size-change="handleUpdateData()"
      @handleCurrentChangeSub="handleCurrentChangeSub"
    ></Pagination>
  </div>
</div>
</template>

<script>
import $ from "jquery";
import Pagination from "@/common/Pagination";
import {reqSearchCategory} from '../api/index.js'
import {READ_URL, RESOURCE_TYPE_READ, LOGIN_IN_URL} from '../store/mutation-types'
import {mapState} from 'vuex'
export default {
  name: "ContenCategory",
  components: {
    Pagination
  },
  computed: {
    ...mapState(['userinfo'])
  },
  data() {
    return {
      Facelist: [],
      sortType: "BookTitle",
      BaseUrl: "http://static.wanfangdata.com.cn/LocalChronicleImages/",
      hit: 0,
      totalPage: 0,
      fq: ["Province:", "City:"],
      pageNo: 1,
      pageSize: 15,
      paginationReady: false,

      // 封装查询参数
      searchData: {
        query: "",
        fq: [],
        core: "LocalChronicleOpera",
        pageSize: 15,
        pageNo: 1,
        sorts: []
      },
      defaultImg:
        'this.src="http://static.wanfangdata.com.cn/LocalChronicleImages/FZ201745248.gif"'
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return;
      if (value.length > 125) {
        return value.slice(0, 125) + "...";
      }
      return value;
    },
    ellipsisTiltle(value) {
      if (!value) return;
      if (value.length > 40) {
        return value.slice(0, 40) + "...";
      }
      return value;
    },
    ellipsisMessage(value) {
      if (!value) return;
      if (value.length > 20) {
        return value.slice(0, 20) + "...";
      }
      return value;
    }
  },
  methods: {
    // 重组路由参数
    _installRouterParam (Province, City, sortType, pageNo) {
      let _Province = this.$route.query.Province
      let _City = this.$route.query.City
      let _sortType = this.$route.query.sortType
      let _pageNo = this.$route.query.pageNo * 1
      if(Province) {
        _Province = Province
      }
      if(City) {
        _City = City
      }
      if(sortType) {
        _sortType = sortType
      }
      if(pageNo) {
        _pageNo = pageNo
      }
      if(City) {
        this.$router.replace(
          {path:'category', 
            query: {City: _City, sortType: _sortType, pageNo: _pageNo}
          })
      }else if(Province) {
        this.$router.replace(
          {path:'category', 
            query: {Province: _Province,  sortType: _sortType, pageNo: _pageNo}
          })
      }else {
        this.$router.replace(
          {path:'category', 
            query: {sortType: _sortType, pageNo: _pageNo}
          })
      }
    },
    // 根据路由参数发请求
    _getDataByRouterParam () {
      const Province = this.$route.query.Province
      const City = this.$route.query.City
      const sortType = this.$route.query.sortType
      const pageNo = this.$route.query.pageNo
      if(City) {
        this.searchData.fq = ['City:' + City]
        //this.handleUpdateData(opt)
      }else if(!City && Province) {
        this.searchData.fq = ['Province:' + Province]
      }
      if (sortType == "BookTitle") {
        this.searchData.sorts = [{feild: 'BookTitle', order: 'desc'}]
      }else {
        this.searchData.sorts = [{feild: 'Date', order: 'desc'}]
      }
      this.searchData.pageNo = pageNo
      this.handleUpdateData(this.searchData)
    },
    // 跳转志书详情页
    async handleDetail (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: '/detail', 
          query: { BookID: id} 
        })
      }
    },
    // 根据路由参数，moutend 检索
    searchByRoute () {
      const Province = this.$route.query.Province
      const City = this.$route.query.City
      if(City) {
        const opt = {
          fq: ['City:' + City]
        }
        this.handleUpdateData(opt)
      }else {
        const opt = {
          fq: ['Province:' + Province]
        }
        this.handleUpdateData(opt)
      }
    },
    // 整书在线阅读
    async handleCilicRead (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 整书 2
        this.$store.dispatch('savSourceType', 2)
        if(this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_READ)
        }else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 排序
    async handleSort (sortType) {
      if (await this.$loginAuthentication.intercept(0)) {
        this._installRouterParam(false, false, sortType, 1)
        //this._getDataByRouterParam ()
      }
    },
    // 更新页面数据
    async handleUpdateData(opt) {
      const result =  await reqSearchCategory(opt)
      const data = result.resulter // 获取对象resulter
      this.Facelist = JSON.parse(data.results)
      this.hit = data.hit
      this.totalPage = data.totalPage
      this.curPageFlag = data.curPage
      this.pageSizeFlag = data.pageSize
    },
    // 页码变化
    async handleCurrentChangeSub (val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.pageNo = val
        this._installRouterParam (false, false, false, val)
      }
    }
  },
  props: {
    queryCondition: Array,
    filterList: Array
  },
  mounted() {
    // 初始化页面
    this._getDataByRouterParam ()
  },
  watch: {
    // 翻页更新数据
    pageNo (val) {
      const opt = {
        pageNo: val,
        fq: this.filterList,
        sorts:[{feild: this.sortType, order:'desc'}],
      }
      this.handleUpdateData(opt)
    },
    $route: {
      handler: function(val) {
       this._getDataByRouterParam()
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
@import url(~styles/varibles.less);
.container_wrapper {
  width: 1200px;
  margin: 0 auto;
  min-height: 1348px;
  .container-inner {
    box-sizing: border-box;
    padding: 28px 0;
    margin: 0 20px;
    height: 258px;
    border-bottom: 1px solid @line-color;
    font-size: 14px;
    color: #666;
    .left {
      float: right;
      width: 1000px;
      height: 100%;
    }
    .right {
      float: left;
      width: 150px;
      height: 100%;
      .book-img {
        height: 195px;
        width: 138px;
        background: red;
        border: 2px solid #ddd;
      }
    }
  }
}
.itemTitle {
  font-size: 20px;
  color: #333;
  display: block;
  padding-left: 15px;
  padding-bottom: 15px; 
  .itemTopic {
    display: inline-block;
    max-width: 800px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      color: #94491f;
    }
  }
  .itemArea {
    font-size: 12px;
    background: @area-color;
    color: #fff;
    border-radius: 3px;
    margin-left: 8px;
  }
}
.itemMessage {
  font-size: 14px;
  width: 360px;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 20px;
  .item {
    width: 280px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
  }
  span {
    float: left;
  }
}
.itemContent {
  max-height: 80px;
  background: #f2eeeb;
  color: #94491f;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.reading {
  width: 128px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: #a31f24;
  color: #fff;
  border-radius: 28px;
  margin-left: 22px;
  float: right;
  cursor: pointer;
  span {
    margin-right: 7px;
  }
}
.SortItem {
  font-size: 14px;
  height: 64px;
  line-height: 64px;
  width: 1200px;
  //margin: 18px 30px 13px 30px;
  border-bottom: 1px solid @line-color;
  margin: 0 auto;
  .resultTotal {
    display: inline-block;
    color: #333;
    margin-left: 20px;
    span {
      color: #94491f;
    }
  }
  .sortBtn {
    cursor: pointer;
    .selectBtn {
      border: 1px solid #94491f;
      color: #fff;
      .iconfont {
        color: #fff;
      }
    }
    height: 64px;
    float: right;
    line-height: 64px;
    .orderByName {
      line-height: 30px;
      display: inline-block;
      border: 1px solid #d5c2b8;
      border-radius: 30px;
      color: #94491f;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 38px;
      line-height: 38px;
      padding-left: 20px;
      padding-right: 14px;
      .iconfont {
        color: #ccc;
      }
    }
    .orderByTime {
      line-height: 30px;
      display: inline-block;
      border: 1px solid #d5c2b8;
      border-radius: 30px;
      color: #94491f;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 38px;
      line-height: 38px;
      text-align: center;
      text-align: center;
      padding-left: 18px;
      padding-right: 14px;
      margin-left: 10px;
      .iconfont {
        color: #ccc;
      }
    }
  }
}
#app {
  .SortItem {
    .sortBtn {
      .selectBtn {
        border: 1px solid #94491f;
        color: #fff;
        background: #94491f;
        .iconfont {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/ContenCategory.vue